{
  "assetsFolder": "https://s1.quebecormedia.com/infojdem/2023/salaire-des-elus/"
}
